/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface GetBilling200Response
 */
export interface GetBilling200Response {
    /**
     * 
     * @type {string}
     * @memberof GetBilling200Response
     */
    message?: string;
    /**
     * 
     * @type {any}
     * @memberof GetBilling200Response
     */
    billingData?: any | null;
}


/**
 * Check if a given object implements the GetBilling200Response interface.
 */
export function instanceOfGetBilling200Response(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function GetBilling200ResponseFromJSON(json: any): GetBilling200Response {
    return GetBilling200ResponseFromJSONTyped(json, false);
}

export function GetBilling200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBilling200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': !exists(json, 'message') ? undefined : json['message'],
        'billingData': !exists(json, 'billingData') ? undefined : json['billingData'],
    };
}

export function GetBilling200ResponseToJSON(value?: GetBilling200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
        'billingData': value.billingData,
    };
}

